export const BRAND = {
	GENERIC: 'generic',
	SEVEN_BREW: '7brew'
} as const;
export type TBrand = typeof BRAND[keyof typeof BRAND];
